export default function Counselors() {
  const counselors = [
    {
      id: 1,
      name: '이승은 대표',
      title: '센터장',
      specialty: ['아동심리학 박사', '학교폭력 심리 전문가', '수원지방검찰청 평택지원 시민검찰위원', '평택보호관찰소 특별위원', "동화 '수거' 작가"],
      image: 'https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/ddd24e2096bf50b3aa70d1bf7ad5f72b.webp',
      certifications: ['아동심리학 박사', '학교폭력 심리 전문가', '수원지방검찰청 평택지원 시민검찰위원', '평택보호관찰소 특별위원', "동화 '수거' 작가"],
    },
    {
      id: 2,
      name: '이은미',
      title: '상담사',
      specialty: ['상담학 박사', '청소년상담사 1급', '전문상담교사'],
      image: 'https://static.readdy.ai/image/c95eae3c0292d162e81be57d2547304f/2c6e04b6272ca586762058cb3aef4f63.png',
      certifications: ['상담학 박사', '청소년상담사 1급', '전문상담교사'],
    }
  ];

  return (
    <section id="counselors" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-[11px] font-semibold text-[#A8B5A0] tracking-widest uppercase mb-3">Our Counselors</span>
          <h2 className="text-[26px] font-bold text-[#2C2C2C] mb-3">상담사 안내</h2>
          <p className="text-[15px] text-[#666666]">
            풍부한 경험과 전문성을 갖춘 상담사들이 함께합니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {counselors.map((counselor) => (
            <div
              key={counselor.id}
              className="bg-[#FAF8F5] rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="w-full h-[220px] overflow-hidden">
                <img
                  src={counselor.image}
                  alt={counselor.name}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>

              <div className="px-5 py-4">
                <h3 className="text-[15px] font-bold text-[#2C2C2C] mb-1">{counselor.name}</h3>
                <p className="text-[12px] text-[#A8B5A0] font-medium mb-3">{counselor.title}</p>

                <ul className="space-y-1">
                  {counselor.certifications.map((cert) => (
                    <li key={cert} className="flex items-start gap-2 text-[12px] text-[#555555]">
                      <span className="mt-[5px] w-1.5 h-1.5 rounded-full bg-[#6B8F6B] flex-shrink-0"></span>
                      {cert}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
